import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import DataSetFrom from "./DataSetFrom";

export default function AddDatasetForm() {
  const { t } = useTranslation("wine");
  const navigate = useNavigate();

  return (
    <div className="content my-4">
      <div className="d-flex mb-4 flex-wrap gap-16 align-items-center justify-content-between col-reverse">
        <Button
          onClick={() => navigate(-1)}
          className="btn btn-primary d-flex align-items-center align-self-center"
        >
          <i
            className="tim-icons icon-minimal-left
              
              font-weight-bold mr-2  font-size-xl"
          ></i>
          <span>{t("common.back")}</span>
        </Button>
        <h2 className="text-capitalize mb-0">{t("form.addTitle")}</h2>
      </div>

      <DataSetFrom />
    </div>
  );
}
